import BaseModel from "./BaseModel";

export default class Newsletter extends BaseModel {

	static entity = 'newsletters';
	static route = 'newsletters';
	static plural = 'newsletters';
	static singular = 'newsletter';

	static fields () {
		return {
			id: this.attr(null),
			web_id: this.attr(null),
			type: this.attr(null),
			emails_sent: this.attr(null),
			send_time: this.attr(null),
			recipient: this.attr(null),
			subject_line: this.attr(null),
			preview_text: this.attr(null),
			title: this.attr(null),
			from_name: this.attr(null),
			reply_to: this.attr(null),
		}
	}

	static configureApi() {
		let config = super.configureApi();
		config.headers = {'Content-Type': 'multipart/form-data'};
		config.actions.view = function(id) {
			return this.get('/'+this.model.route+'/'+id, {
				dataTransformer: () => {
					return [];
				}
			});
		};
		return config;
	}

	static apiConfig = this.configureApi();

}
